module.exports = __webpack_public_path__ + "img/vision_content1.998e733c.png";